var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "task",
      staticClass: "tasks-item",
      class: [
        "tasks-item-state-" + _vm.task.state,
        !(_vm.task.permissions.COMPLETE || _vm.task.permissions.ASSIGN)
          ? "tasks-item-perm-no-open"
          : ""
      ],
      staticStyle: {
        display: "flex",
        "align-items": "last baseline",
        "justify-content": "space-between"
      },
      on: {
        dblclick: function($event) {
          $event.stopPropagation()
          _vm.canUpdate ||
          _vm.task.permissions.ASSIGN ||
          _vm.task.permissions.SCHEDULE
            ? _vm.edit(_vm.canUpdate ? "name" : "user-btn", "div")
            : ""
        }
      }
    },
    [
      _c("div", { staticStyle: { "min-width": "max-content" } }, [
        !_vm.readonly && _vm.task.permissions.DELETE
          ? _c("i", {
              staticClass: "clickable icon-minus-sign text-red",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.remove()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.readonly && !_vm.task.permissions.DELETE
          ? _c("i", { staticClass: "icon-lock" })
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.task.state,
              expression: "task.state"
            }
          ],
          attrs: {
            type: "checkbox",
            disabled:
              _vm.readonly ||
              _vm.task.state == "PLANNED" ||
              !_vm.task.permissions.COMPLETE,
            "true-value": "COMPLETE",
            "false-value": "TODO"
          },
          domProps: {
            checked: Array.isArray(_vm.task.state)
              ? _vm._i(_vm.task.state, null) > -1
              : _vm._q(_vm.task.state, "COMPLETE")
          },
          on: {
            change: function($event) {
              var $$a = _vm.task.state,
                $$el = $event.target,
                $$c = $$el.checked ? "COMPLETE" : "TODO"
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.task, "state", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.task,
                      "state",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.task, "state", $$c)
              }
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-flow": "row wrap",
            "flex-grow": "1"
          },
          style: { "flex-direction": _vm.task.editing ? "column" : "row" }
        },
        [
          _c("div", { staticStyle: { padding: "3px" } }, [
            (!_vm.task.editing || !_vm.canUpdate) && _vm.task.date
              ? _c("span", { staticClass: "rm-task-date" }, [
                  _vm._v(_vm._s(_vm.formattedDate))
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.task.editing || !_vm.canUpdate
              ? _c("span", [_vm._v(_vm._s(_vm.task.name))])
              : _vm._e(),
            _vm._v(" "),
            !_vm.task.editing && _vm.task.assignee !== undefined
              ? _c("span", { staticClass: "rm-task-assignee" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.task.assignee.username) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.task.editing && _vm.canUpdate
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.task.name,
                      expression: "task.name"
                    }
                  ],
                  staticClass: "rm-task-name",
                  attrs: { type: "text" },
                  domProps: { value: _vm.task.name },
                  on: {
                    keyup: [
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.unedit("keyup")
                      },
                      function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "escape",
                            undefined,
                            $event.key,
                            undefined
                          )
                        ) {
                          return null
                        }
                        return _vm.unedit("keyup")
                      }
                    ],
                    dblclick: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.task, "name", $event.target.value)
                    }
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.task.editing &&
          _vm.task.permissions.ASSIGN &&
          (_vm.task.assignee !== undefined || _vm.showUserSearch)
            ? _c(
                "div",
                { staticStyle: { padding: "3px", "text-align": "right" } },
                [
                  _vm.task.assignee !== undefined
                    ? _c("span", { staticStyle: { "padding-right": "5px" } }, [
                        _c("a", {
                          staticClass: "clickable icon-user rm-task-user-btn",
                          attrs: { tabindex: "-1" },
                          on: {
                            click: function($event) {
                              _vm.task.assignee = undefined
                              _vm.focus(
                                _vm.task.permissions.DELETE
                                  ? "name"
                                  : "user-btn"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "rm-task-assignee" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.task.assignee.username) +
                              "\n            "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showUserSearch
                    ? _c("UsermTypeahead", {
                        attrs: {
                          usermBaseUrl: _vm.usermBaseUrl,
                          i18n: _vm.i18n,
                          fixedItems: _vm.fixedItems
                        },
                        on: {
                          enter: function($event) {
                            return _vm.unedit("enter")
                          },
                          escape: function($event) {
                            return _vm.unedit("escape")
                          }
                        },
                        model: {
                          value: _vm.task.assignee,
                          callback: function($$v) {
                            _vm.$set(_vm.task, "assignee", $$v)
                          },
                          expression: "task.assignee"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.task.editing && _vm.task.permissions.ASSIGN
            ? _c(
                "div",
                { staticStyle: { padding: "3px", "align-self": "flex-end" } },
                [
                  _vm.task.editing &&
                  _vm.task.assignee === undefined &&
                  !_vm.showUserSearch
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-mini rm-task-user-btn",
                          attrs: { title: "Assign" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.assign()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "clickable icon-plus" }),
                          _vm._v(" "),
                          _c("i", { staticClass: "clickable icon-user" })
                        ]
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.task.editing && (_vm.task.permissions.SCHEDULE || !!_vm.task.date)
            ? _c(
                "div",
                { staticStyle: { padding: "3px", "text-align": "right" } },
                [
                  !!_vm.task.date
                    ? _c("span", { staticStyle: { "padding-right": "5px" } }, [
                        _vm.task.permissions.SCHEDULE
                          ? _c("a", {
                              staticClass: "clickable icon-calendar",
                              attrs: { tabindex: "-1" },
                              on: {
                                click: function($event) {
                                  _vm.$set(_vm.task, "date", undefined)
                                  _vm.focus(
                                    _vm.task.permissions.DELETE
                                      ? "name"
                                      : "date-btn"
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "rm-task-date" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formattedDate) +
                              "\n            "
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "min-width": "max-content",
            "align-self": "auto",
            padding: "0 5px 0 0"
          }
        },
        [
          !_vm.readonly
            ? _c("i", { staticClass: "icon-align-justify rm-task-handle" })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.debug
        ? _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                "margin-top": "-10px",
                color: "lightslategray",
                "font-size": "smaller"
              }
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    Object.entries(_vm.task.permissions)
                      .concat([["UPDATE", _vm.canUpdate]])
                      .filter(function(e) {
                        return e[1]
                      })
                      .map(function(e) {
                        return e[0][0]
                      })
                      .join(" ")
                  )
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }